export const HIERARCHY_REDUCER_STATE_ID = 'hierarchyTypeSelector';
export const ROUTE_BROWSE = '/browse';
export const STATE_SUFFIX_HIERARCHY_TABLE = '_hierarchy';
export const HIERARCHY_SEARCH_COMPONENTS = {
  files: false,
  hierarchy: false,
  parentHierarchy: false,
};
